module.exports = __webpack_public_path__ + "static/media/home-slide2.e20d4462.webp";